var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkAsReadDisable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.499756,
    width: 23,
    height: 23,
    rx: 4.5,
    stroke: "#CACACA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 3.99976,
    width: 16,
    height: 16,
    fill: "#CACACA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 21.9998C7.286 21.9998 4.929 21.9998 3.464 20.5348C2 19.0718 2 16.7138 2 11.9998C2 7.28576 2 4.92876 3.464 3.46376C4.93 1.99976 7.286 1.99976 12 1.99976C16.714 1.99976 19.071 1.99976 20.535 3.46376C22 4.92976 22 7.28576 22 11.9998C22 16.7138 22 19.0708 20.535 20.5348C19.072 21.9998 16.714 21.9998 12 21.9998ZM14.474 8.41876C14.628 8.5445 14.7259 8.72627 14.7459 8.9241C14.766 9.12194 14.7067 9.31965 14.581 9.47376L8.867 16.4738C8.79666 16.5599 8.70804 16.6294 8.60755 16.6771C8.50707 16.7247 8.39723 16.7495 8.286 16.7495C8.17477 16.7495 8.06493 16.7247 7.96445 16.6771C7.86396 16.6294 7.77534 16.5599 7.705 16.4738L5.419 13.6738C5.29835 13.5192 5.24305 13.3235 5.26494 13.1286C5.28684 12.9337 5.38419 12.7552 5.53614 12.6312C5.68809 12.5072 5.88255 12.4477 6.07786 12.4654C6.27316 12.4831 6.45378 12.5765 6.581 12.7258L8.286 14.8138L13.419 8.52576C13.5447 8.37171 13.7265 8.2739 13.9243 8.25383C14.1222 8.23377 14.3199 8.29309 14.474 8.41876ZM18.474 8.41876C18.6281 8.5445 18.7259 8.72627 18.7459 8.9241C18.766 9.12194 18.7067 9.31965 18.581 9.47376L12.867 16.4738C12.7924 16.5653 12.6973 16.638 12.5894 16.6859C12.4814 16.7338 12.3637 16.7555 12.2457 16.7492C12.1278 16.743 12.013 16.709 11.9107 16.65C11.8084 16.591 11.7215 16.5087 11.657 16.4098L11.372 15.9718C11.2863 15.8403 11.244 15.6852 11.2511 15.5285C11.2582 15.3717 11.3143 15.2211 11.4114 15.0979C11.5086 14.9747 11.642 14.885 11.7928 14.8416C11.9435 14.7981 12.1042 14.8031 12.252 14.8558L17.419 8.52576C17.5447 8.37171 17.7265 8.2739 17.9243 8.25383C18.1222 8.23377 18.3199 8.29309 18.474 8.41876Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkAsReadDisable);
export default __webpack_public_path__ + "static/media/markAsReadDisable.965431bea3d75793695435d843b2ed9c.svg";
export { ForwardRef as ReactComponent };